<template>
    <div class="lecture-collapse p-2" @click="handleclick($event)">
        <div class="wrap-name-item display-flex-center">
            <input v-if="!isDisabledCheckbox" type="checkbox" :id="'check_' + item.id" class="form-control" />
            <label for="checkbox" class="name-post m-0" :for="'check_' + item.id">{{ item.name }}</label>
        </div>
    </div>
</template>
<script>

export default{
    props:{
        item:{
            type:Object,
            default:{}
        },
        isDisabledCheckbox:{
            type:Boolean,
            default: false
        }
    },
    data(){
        return{
            
        }
    },
    methods:{
        handleclick(event) {
            this.$emit(`handleclick`, event, this.item);
        }
    }
}
</script>
<style lang="scss" scoped>
.wrap-name-item{
    cursor: pointer;
    column-gap: 0.5rem;
}
.name-post {
    cursor: pointer;
    color: #007bff;
}
input[type=checkbox] {
    width: 20px;
    height: 20px;
    cursor: pointer;
}
</style>